import ajax from './ajax';
import { API_DOMAIN } from '../utils/constants';

const post = (path, data) => ajax(`${API_DOMAIN}/api/a/${path}`, data, 'POST', true).then(response => {
  if (response.code && Number(response.code) !== 200) throw new Error(response.msg || 'Request failed.');
  return response.data;
});
export const previewOrderExport = data => post('preview-order-export', data);
export const exportOrders = data => post('export-orders', data);
export const previewTrackingImport = data => post('preview-tracking-import', data);
export const importOrderTracking = data => post('import-order-tracking', data);
export const orderTransferStatus = data => post('order-transfer-status', data);
export const syncOrderTracking = data => post('sync-order-tracking', data);
export const orderImportResult = data => post('order-import-result', data);
export const releaseOrderExport = data => post('release-order-export', data);

export const orderExportTemplates = data => post('order-export-templates', data);
export const saveOrderExportTemplate = data => post('save-order-export-template', data);
export const deleteOrderExportTemplate = data => post('delete-order-export-template', data);
export const downloadOrderExport = async data => {
  try { return await ajax(`${API_DOMAIN}/api/a/download-order-export`, data, 'POST', true, { responseType: 'blob' }); }
  catch (error) {
    if (error.response?.data instanceof Blob) {
      try { error.response.data = JSON.parse(await error.response.data.text()); } catch {}
    }
    throw error;
  }
};

export const inspectTrackingCsv = data => post('inspect-tracking-csv', data);
